<template>
    <div>
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand href="#" disabled>疾病判讀系統</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item href="/clientlist">一般用戶</b-nav-item>
            <b-nav-item v-if="level == 'admin'" href="/accountmanage">帳號管理</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown text="語言" right>
              <b-dropdown-item @click="setLang('tw')">繁體中文</b-dropdown-item>
              <b-dropdown-item @click="setLang('cn')">简体中文</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-navbar-nav>
              <b-nav-item href="" @click="signout">登出</b-nav-item>
            </b-navbar-nav>
          </b-navbar-nav>

        </b-collapse>
      </b-navbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
        level: '',
    }
  },
  created(){
        const user = JSON.parse(sessionStorage.getItem('my_info'));
        this.level = user[0].level;
  },
  methods: {
    signout(){
      sessionStorage.clear();
      this.$router.push('/login');
    },
    setLang(value) {
      // this.$store.commit('setLang', value);
      this.$i18n.locale = value;
      localStorage.setItem('footmark-lang', value);
    }
  }
}
</script>

